import { convertFromRaw } from 'draft-js'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'
import * as React from 'react'
import { connect } from 'react-redux'
// import Row from 'components/common/row'
import type { FooterProps } from 'types/content-editor'
import type { CampaignFooter } from 'types/content-editor'
import { getDefaultCampaignFooter } from '@disco/state-management/selectors/campaigns'
import exportToMjml from '@disco/content-editor/mjml-export'
import { fixLink } from '@disco/utils/links'
import RichTextEditor from 'components/common/rich-text-editor'
import Input from 'components/ui/input'
import Label from 'components/ui/label'
const footerTemplate: CampaignFooter = {
  footer_text: null,
  footer_text_mjml: '',
  social_links: {},
}

const mapStateToProps = state => {
  const footer = getDefaultCampaignFooter(state) || footerTemplate
  return {
    footer,
  }
}

class FooterBlockSettings extends React.Component<{
  content: FooterProps
  footer: CampaignFooter
  onChange: (arg0: Record<string, any>) => any
  validationErrors: Record<string, string> | null | undefined
}> {
  _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = cloneDeep(this.props.content.footer || this.props.footer)
    set(value, e.target.name, fixLink(e.target.value))
    this.props.onChange({ ...this.props.content, footer: value })
  }
  _onTextChange = (contentObject: Record<string, any> | null | undefined) => {
    if (!contentObject && !this.props.content.footer) return
    const value = {
      ...(this.props.content.footer || this.props.footer),
      footer_text: contentObject || '',
      footer_text_mjml: contentObject
        ? exportToMjml(convertFromRaw(contentObject || {}), {})
        : '',
    }
    this.props.onChange({ ...this.props.content, footer: value })
  }

  _renderSocialInput(caption: string, value: string, name?: string) {
    const { validationErrors } = this.props
    const link = name ? name : caption.toLowerCase()
    return (
      <div className="rich-text-toolbar__settings__list__row">
        <Label
          validationError={validationErrors && validationErrors[link]}
          caption={caption}
        />
        <Input
          value={value}
          name={`social_links.${link}`}
          onChange={this._onChange}
          className="Campaigns_LargeInput"
        />
      </div>
    )
  }

  render() {
    const footer = this.props.content.footer || this.props.footer
    return (
      <div className="content-editor__playlist-block">
        {this._renderSocialInput(
          'Facebook',
          get(footer, 'social_links.facebook', ''),
        )}
        {this._renderSocialInput(
          'X',
          get(footer, 'social_links.twitter', ''),
          'twitter',
        )}
        {this._renderSocialInput(
          'Soundcloud',
          get(footer, 'social_links.soundcloud', ''),
        )}
        {this._renderSocialInput(
          'Instagram',
          get(footer, 'social_links.instagram', ''),
        )}
        {this._renderSocialInput(
          'Spotify',
          get(footer, 'social_links.spotify', ''),
        )}
        {this._renderSocialInput(
          'Apple Music/iTunes',
          get(footer, 'social_links.apple', ''),
          'apple',
        )}
        {this._renderSocialInput(
          'Website',
          get(footer, 'social_links.web', ''),
          'web',
        )}
        {this._renderSocialInput(
          'YouTube',
          get(footer, 'social_links.youtube', ''),
        )}
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Footer text" />
          <RichTextEditor
            className="CampaignDetails_Input"
            initialContent={footer.footer_text}
            onChange={this._onTextChange}
          />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, {})(FooterBlockSettings) as any
